import { Injectable } from '@angular/core';
import { GraphClientService } from './graph-client-service';
import { DiagnosticsServiceFactory } from './diagnostics-service-factory';
import { IDiagnosticsService } from './interfaces';
import { Observable } from 'rxjs';
import { QnAResultsParser } from './qna-results-parser';

export class QnAResults {
  public searchRefiners: any[] = [];
  public searchResults: any[] = [];
}

@Injectable({
  providedIn: 'root'
})
export class QnAService {
  private _diagnostics: IDiagnosticsService;
  private _qnaParser: QnAResultsParser;

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    private _graphClient: GraphClientService) {
    this._diagnostics = diagnosticsFactory.create(this.constructor.name);
    this._qnaParser = new QnAResultsParser();
  }

  public runQuery(urlKey: string, query: string, refiner: string, accessToken: any): Observable<QnAResults> {
    const queryText = (query) ? query : "*";
    const filter = (refiner) ? "&refinementfilters='RefinableString05:\"" + refiner + "\"'" : "";
    const searchArgs = [queryText, filter];
    return this._graphClient.getDataWithParameters(urlKey, null, searchArgs, accessToken).map(
      data => {
        const dynamicData = data as any;
        const qnaResult = new QnAResults();
        qnaResult.searchResults = this._qnaParser.buildPrimaryResults(dynamicData);
        qnaResult.searchRefiners = (qnaResult.searchResults && qnaResult.searchResults.length > 0) ? this._qnaParser.buildRefinerTree(dynamicData) : [];
        return qnaResult;
      }, error => {
        this._diagnostics.logError(`QnA: Error loading data. Details: ${JSON.stringify(error)}`);
      });
  }
}
